// extracted by mini-css-extract-plugin
export var arrow = "sidenavfilter-styles-module--arrow--a5bcd";
export var dropdownWrap = "sidenavfilter-styles-module--dropdown-wrap--4b740";
export var filterContainer = "sidenavfilter-styles-module--filter-container--1ae74";
export var filterIconWrap = "sidenavfilter-styles-module--filter-icon-wrap--bf868";
export var filterInputWrap = "sidenavfilter-styles-module--filter-input-wrap--66779";
export var filterSidenav = "sidenavfilter-styles-module--filter-sidenav--060b0";
export var search = "sidenavfilter-styles-module--search--94c1a";